import axios from 'axios'

function normalizeLoginData (data) {
  const loginData = data || {}
  return {
    userId: loginData.userId || loginData.id || '',
    token: loginData.token || '',
    phone: loginData.phone || loginData.mobile || '',
    name: loginData.name || loginData.realname || loginData.patientName || '',
    shundeHospitalCode: loginData.shundeHospitalCode || loginData.hospitalCode || '',
    shundeHospitalName: loginData.shundeHospitalName || loginData.hospitalName || '',
    registerHospitalId: loginData.registerHospitalId || '',
    registerHospitalBusinessId: loginData.registerHospitalBusinessId || '',
    registerHospitalName: loginData.registerHospitalName || '',
    debugContentJson: loginData.debugContentJson || '',
    raw: loginData
  }
}

const InternetHospitalAuthDao = {
  async login ({ appId, content, openid, returnUrl }) {
    const url = '/internet-hospital/h5/login'
    const { data: resp } = await axios.post(url, {
      appId,
      content,
      openid,
      returnUrl,
      debugContent: true
    })
    console.log('健康顺德小程序 H5 授权登录响应:', resp)

    const {
      code,
      data,
      message,
      msg
    } = resp || {}

    if (code !== 200 || !data) {
      return {
        code: 2,
        msg: message || msg || '授权登录失败'
      }
    }

    return {
      code: 1,
      data: normalizeLoginData(data)
    }
  }
}

export default InternetHospitalAuthDao
